function initModalDialogs() {
    jQuery('#modal-dialog').remove();
    jQuery('body').append(jQuery('#modal-dialog-template').html());

    jQuery('#modal-dialog .btn-primary').off('click').on('click', function(e) {
        if (!jQuery(this).data('enable-submit')) {
            jQuery(this).button('reset').removeAttr('disabled').button('loading');
        }
        jQuery('#modal-dialog form').submit();
    });

    jQuery(document).off('click', '.modal-dialog-link');
    jQuery(document).on('click', '.modal-dialog-link', function() {
        if (typeof jQuery(this).data('confirm') == 'undefined' || confirm(jQuery(this).data('confirm')) ) {
            var link = jQuery(this);
            openModalDialog({
                title: link.data('title'),
                modalClass: link.data('modal-class'),
                modalStyle: link.data('modal-style'),
                hideButtons: link.data('hide-buttons'),
                hideSaveButton: link.data('hide-save-button'),
                saveLabel: link.data('save-label'),
                content: link.data('content'),
                url: link.attr('href') || '',
                onSubmit: link.data('on-submit'),
                // onCancel: link.data('on-cancel'),
                enableSubmit: link.data('enable-submit'),
                hideBackdrop: link.data('hide-backdrop')
            }, link);
        }

        return false;
    });

    // jQuery('table').off('draw.dt').on('draw.dt', initModalDialogs);

    // Reinitialize modal dialog on close to clear button event bindings
    // since buttons are part of dialog template.
    jQuery('body').off('hide.bs.modal', '#modal-dialog', initModalDialogs).on('hide.bs.modal', '#modal-dialog', initModalDialogs);
    jQuery('body').off('hide.bs.modal', '#modal-dialog', cleanActiveDialogLinks).on('hide.bs.modal', '#modal-dialog', cleanActiveDialogLinks);
}

function openModalDialog(options, link) {
    jQuery('.modal-dialog-link').removeClass('dialog-active')
    link?.addClass('dialog-active')
    var dialog = jQuery('#modal-dialog');
    var cancelButton = dialog.find('[data-dismiss="modal"]');
    var primaryButton = dialog.find('.modal-footer button.btn-primary');

    dialog.find('.modal-title').html(options.title);
    dialog.find('.modal-dialog').removeClass('modal-sm').removeClass('modal-lg').addClass(options.modalClass);

    if (options.hideButtons) {
        dialog.find('.modal-footer').hide();
    } else if (options.hideSaveButton) {
        dialog.find('.modal-footer [data-dismiss="modal"]').removeClass('pull-left').html(I18n.t('close'));
        dialog.find('.modal-footer .btn-primary').hide();
    } else {
        dialog.find('.modal-footer').show();
        primaryButton.html(options.saveLabel || I18n.t('save'));
        primaryButton.button('reset').removeAttr('disabled');
        primaryButton.data('enable-submit', options.enableSubmit);
    }

    if (options.modalStyle)
      jQuery(dialog.find('.modal-dialog')).attr('style', options.modalStyle);

    dialog.modal();
    if(options.hideBackdrop){
        jQuery('.modal').addClass('no-backdrop')
        jQuery('.modal-backdrop').addClass('hidden')
    }else{
        jQuery('.modal').removeClass('no-backdrop')
        jQuery('.modal-backdrop').removeClass('hidden')
    }

    // Enable background page scrolling when modal contains a class named (.modal-background-scrolling)
    jQuery('.modal:has(.modal-background-scrolling)').css({position: 'absolute'}).parent().removeClass('modal-open');

    if ((options.url || '').length > 1) {
        dialog.find('.modal-body').html(SmartME.loadingIndicator());
        function processFormLoad(res, status) {
            if (status == 'error') {
                if (options.errorCallback && typeof options.errorCallback === 'function') {
                  options.errorCallback();
                } else {
                  alert(res.message ? res.message : I18n.t('unexpected_error'));
                  cancelButton.trigger('click');
                }
            } else {
                AdaliaForm.init('#modal-dialog');
                dialog.trigger('modal:loaded');
            }
        }
        if (options.method && options.method === 'POST'){
            dialog.find('.modal-body').load(options.url, options.requestBody ,processFormLoad);
        } else {
            dialog.find('.modal-body').load(options.url, processFormLoad);
        }
    } else {
        dialog.find('.modal-body').html(options.content);
    }

    if (typeof options.onSubmit == 'function') {
        primaryButton.off('click');
        primaryButton.on('click', options.onSubmit);
    }

    if (typeof options.onCancel == 'function') {
        cancelButton.off('click');
        cancelButton.on('click', options.onCancel);
    }

    if (typeof options.onSubmit == 'string') {
        primaryButton.off('click');
        // primaryButton.on('click', function(){ eval(options.onSubmit) });
    }

    // if (typeof options.onCancel == 'string') {
    //     cancelButton.off('click');
    //     cancelButton.on('click', function(){ eval(options.onCancel) });
    // }

    dialog.trigger('modal:opened');
}

function cleanActiveDialogLinks(){
    jQuery('.modal-dialog-link').removeClass('dialog-active')
}

window.openModalDialog = openModalDialog;
window.initModalDialogs = initModalDialogs;
